import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { injectIntl, FormattedMessage } from 'react-intl';
import { Row, Col, ButtonGroup, Button, Form, FormGroup, Alert } from 'react-bootstrap';

import ReactGA4 from 'react-ga4';
import HCaptcha from '@hcaptcha/react-hcaptcha';

import config from '../../../../config.js';

import { capitalizeFirstLetter } from '../../../../util/text.js';

import { contactRequest } from '../../ContactActions.js';
import { getLoggedUser } from '../../../User/UserActions.js';
import { USER_GROUP_DEFAULT } from '../../../User/UserGroupActions.js';
import { displayErrors } from '../../../Error/ErrorActions.js';

import withRouter from '../../../../components/Router/WithRouter.js';
import Icon from '../../../../components/Content/Icon.js';
import FormattedMessageConditionnal from '../../../Intl/components/Translate/FormattedMessageConditionnal.js';
import { getLanguagePath } from '../../../Intl/IntlHelper.js';

class ContactForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            firstName: (props.user && props.user.firstName) || props.search.get('firstName') || '',
            lastName: (props.user && props.user.lastName) || props.search.get('lastName') || '',
            company: (props.user && props.user.company) || props.search.get('company') || '',
            email: (props.user && props.user.email) || props.search.get('email') || '',
            phone: (props.user && props.user.phone) || props.search.get('phone') || '',
            orderNumber: props.search.get('orderNumber') || '',
            message: props.search.get('message') || '',
            isProcessing: false,
            isSent: false,
            errorFields: [],
			isMounted: true,
			isCaptchaSuccess: !config.hcaptcha.siteKey,
        };
    }

    componentDidMount() {
        if(this.props.search.get('autoSubmit')) {
            this.handleSubmit(null, true);
        }
		this.setState({
			isMounted: true,
		});
    }

    handleChange = event => {
        const { target } = event;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const { name } = target;
        this.setState(
            { [name]: value },
        );
    };

    hasErrorField = name => {
        return this.state.errorFields && this.state.errorFields.indexOf(name) !== -1;
    };

    handleSubmit = (event, force = false) => {
        event && event.preventDefault();

		if(!this.props.search.get('autoSubmit') && !this.props.user && !this.state.isCaptchaSuccess) {
			this.setState({
				errorFields: ['captcha'],
			});
		} else if(force || (this.state.email && this.state.phone && this.state.message)) {
				this.setState({
					isProcessing: true,
				});

				this.props.dispatch(contactRequest({
					email: this.state.email,
					firstName: this.state.firstName,
					lastName: this.state.lastName,
					phone: this.state.phone,
					company: this.state.company,
					_id: this.props.user && this.props.user._id,
				}, this.state.message, { group: this.props.group, orderNumber: this.state.orderNumber })).then(result => {
					this.setState({
						isProcessing: false,
					});
					if(result) {
						this.setState({
							isSent: true,
						});
						displayErrors('success', this.props.intl.formatMessage({
							id: 'alertContactSuccess',
							defaultMessage: 'Well received!',
						}));
						this.handleTrackAnalytics();
					} else {
						displayErrors('error', this.props.intl.formatMessage({
							id: 'alertContactError',
							defaultMessage: 'Unable to send your message! Please retry...',
						}));
					}
				});
			} else {
				this.setState({
					errorFields: ['email', 'phone', 'message'].filter(field => !this.state[field]),
				});
			}
    };

    handleTrackAnalytics = () => {
        if(typeof window !== 'undefined' && config.google.analytics.trackingCodeGA4) {
            // GA: New
            ReactGA4.event('generate_lead');
        }
        if(typeof window !== 'undefined' && window.fbq) {
            // TODO: Track contact form submit on Fb Pixel
        }
    };

    render() {
        return (
            <div>
                {
                    this.state.isSent
                    ? (
                        <div className="text-center">
                            <h4 className="text-success"><Icon icon="thumbs-up" /> <FormattedMessage id="alertContactSuccess" defaultMessage="Well received!" /></h4>
                            <Button variant="outline-success" as={Link} to={getLanguagePath('/', this.props.intl.locale)}><Icon icon="chevron-left" /> <FormattedMessage id="back" defaultMessage="Back" /></Button>
                        </div>
                    ) : (
                        <Fragment>
                            <p>
                                {
                                    this.state.isMounted && this.props.group && this.props.group !== USER_GROUP_DEFAULT
                                    ? <FormattedMessageConditionnal id={`contactPageTextGroup${capitalizeFirstLetter(this.props.group)}`} defaultMessage="Want to create your {group} account? Let us know about you and your activity" values={{ group: this.props.group }} />
                                    : <FormattedMessage id="contactPageText1" defaultMessage="Need help to order? Want information for a product? We are here to help you!" />
                                }
                            </p>
							{this.state.isMounted && (
								<Form onSubmit={this.handleSubmit}>
									<Row>
										<Col xs="12" sm="6">
											<FormGroup className={this.hasErrorField('firstName') ? 'has-danger' : ''}>
												<Form.Label for="firstNameField"><FormattedMessage id="userFirstName" defaultMessage="First name" /></Form.Label>
												<Form.Control type="text" name="firstName" id="firstNameField" className={this.hasErrorField('firstName') ? 'is-invalid form-control-danger' : ''} onChange={this.handleChange} placeholder="" value={this.state.firstName} />
											</FormGroup>
										</Col>
										<Col>
											<FormGroup className={this.hasErrorField('lastName') ? 'has-danger' : ''}>
												<Form.Label for="lastNameField"><FormattedMessage id="userLastName" defaultMessage="Last name" /></Form.Label>
												<Form.Control type="text" name="lastName" id="lastNameField" className={this.hasErrorField('lastName') ? 'is-invalid form-control-danger' : ''} onChange={this.handleChange} placeholder="" value={this.state.lastName} />
											</FormGroup>
										</Col>
									</Row>
									{this.props.group && this.props.group !== USER_GROUP_DEFAULT && (
										<FormGroup className={this.hasErrorField('company') ? 'has-danger' : ''}>
											<Form.Label for="companyField"><FormattedMessage id="userCompany" defaultMessage="Company" /></Form.Label>
											<Form.Control type="text" name="company" id="companyField" className={this.hasErrorField('company') ? 'is-invalid form-control-danger' : ''} onChange={this.handleChange} placeholder="" value={this.state.company} />
										</FormGroup>
									)}
									<FormGroup className={this.hasErrorField('email') ? 'has-danger' : ''}>
										<Form.Label for="emailField"><FormattedMessage id="userEmail" defaultMessage="Email" /></Form.Label>
										<Form.Control type="text" name="email" id="emailField" className={this.hasErrorField('email') ? 'is-invalid form-control-danger' : ''} onChange={this.handleChange} placeholder="Email" value={this.state.email} />
									</FormGroup>
									<FormGroup className={this.hasErrorField('phone') ? 'has-danger' : ''}>
										<Form.Label for="phoneField"><FormattedMessage id="userPhone" defaultMessage="Phone" /></Form.Label>
										<Form.Control type="text" name="phone" id="phoneField" className={this.hasErrorField('phone') ? 'is-invalid form-control-danger' : ''} onChange={this.handleChange} placeholder="+33..." value={this.state.phone} />
									</FormGroup>
									<FormGroup>
										<Form.Label for="orderField"><FormattedMessage id="orderNumber" defaultMessage="Order number" /></Form.Label>
										<Form.Control type="text" name="orderNumber" id="orderField" onChange={this.handleChange} placeholder="220901-xxxx" value={this.state.orderNumber} />
									</FormGroup>
									<FormGroup className={this.hasErrorField('message') ? 'has-danger' : ''}>
										<Form.Label for="messageField"><FormattedMessage id="contactMessage" defaultMessage="Message" /></Form.Label>
										<Form.Control as="textarea" name="message" id="messageField" rows="8" className={this.hasErrorField('message') ? 'is-invalid form-control-danger' : ''} onChange={this.handleChange} value={this.state.message} />
									</FormGroup>
									<FormGroup className="mt-3">
										{config.hcaptcha.siteKey && !this.props.user && (
											<Fragment>
												{this.hasErrorField('captcha') && (
													<Alert variant="warning">
														Complete the captcha below
													</Alert>
												)}
												<HCaptcha
													sitekey={config.hcaptcha.siteKey}
													// size="invisible" // not working on free mode
													onClose={() => this.setState({ errorFields: ['captcha'] })}
													onVerify={(token, ekey) => this.setState({ isCaptchaSuccess: true })}
												/>
											</Fragment>
										)}
										<ButtonGroup className="d-flex justify-content-between">
											{this.props.closeForm ? <Button variant="outline-primary" onClick={event => this.props.closeForm()}><Icon icon="chevron-left" /> <FormattedMessage id="back" defaultMessage="Back" /></Button> : null}
											<Button variant="secondary" disabled={this.state.isProcessing} className="w-100" onClick={this.handleSubmit}>{this.state.isProcessing ? <Icon icon="spinner" spin /> : <Icon icon="mail" />} <FormattedMessage id="contactPageButton" defaultMessage="Send" /></Button>
										</ButtonGroup>
									</FormGroup>
								</Form>
							)}
                        </Fragment>
                    )
                }
				{this.props.intl.locale === 'fr' && (
					<div className="my-5 text-center">
						<picture>
							<source srcSet={`${config.url}assets/images/contact.webp`} loading="lazy" />
							<img src={`${config.url}assets/images/contact.png`} alt="Contact" className="d-inline-block mb-1" loading="lazy" />
						</picture>
						<br />
						<FormattedMessage
							id="contactPageText2"
							defaultMessage="You prefer talk with us by phone? <a>Call us at {phone}</a>"
							values={{
								a: msg => <a href={`tel:${config.application.phone}`}>{msg}</a>,
								phone: config.application.phone,
							}}
						/>
					</div>
				)}
            </div>
        );
    }
}

function mapStateToProps(store, props) {
    return {
        user: getLoggedUser(store),
    };
}

ContactForm.defaultProps = {
    user: null,
    group: null,
    closeForm: null,
};

ContactForm.propTypes = {
    dispatch: PropTypes.func.isRequired,
    search: PropTypes.object.isRequired,
    intl: PropTypes.object.isRequired,
    user: PropTypes.object,
    group: PropTypes.string,
    closeForm: PropTypes.func,
};

export default connect(mapStateToProps)(withRouter(injectIntl(ContactForm)));
